const patientAreas = {

  install (Vue, options) {
    Vue.prototype.PatientAreas = {
      1: 'Al Siala',
      2: 'Abis',
      3: 'El Azarita',
      4: 'Al Ibrahimiyyah',
      5: 'Al Hadarh',
      6: 'Ad Dakhilah',
      7: 'El Soyof',
      8: 'Shatby',
      9: 'El Salehya',
      10: 'AZ Zahiriyyah',
      11: 'Asafra',
      12: 'Al Attarin',
      13: 'Awayed',
      14: 'Al Qabari',
      15: 'Labban',
      16: 'Al Mamurah',
      17: 'Al Max',
      18: 'El Mandara',
      19: 'Mansheya',
      20: 'Al Wardiyan',
      21: 'Bacos',
      22: 'Bahary',
      23: 'Bolkly',
      24: 'Gleem',
      25: 'Janaklees',
      26: 'El Montazah',
      27: 'El Gomrok',
      28: 'Ras el Tin',
      29: 'Zizenia',
      30: 'Saba Basha',
      31: 'San Stefano',
      32: 'Stanley',
      33: 'Smouha',
      34: 'Sidy Bishr',
      35: 'Sidy Gaber',
      36: 'Schutz',
      37: 'El Amreya',
      38: 'Fleming',
      39: 'Victoria',
      40: 'Camp Caesar',
      41: 'Karmus',
      42: 'Kafr Abdouh',
      43: 'Kom Ad Dikah',
      44: 'Loran',
      45: 'Moharam Bek',
      46: 'Mahatet El Raml',
      47: 'Mahatet Misr',
      48: 'Toson',
      49: 'Miamy',
      50: 'Mina El Basal',
      51: 'Roshdy',
      52: 'Sporting',
      53: 'Abou Keir',
      54: 'Cleopatra',
      55: 'El Agamy',
      56: 'Fouad Street',
      57: 'King Mariout',
      58: 'Moustafa Kamel',
      59: 'Matrouh',
      60: 'Damanhur',
      61: 'Kafr El dawar',
      62: 'Abu Al Matamir',
      63: 'Abu Hummus',
      64: 'Idku',
      65: 'Itay Al Barud',
      66: 'Badr',
      67: 'Housh Eissa',
      68: 'Ad Dilinjat',
      69: 'AR Rahmaneyah',
      70: 'Rasheed',
      71: 'Shubrakhit',
      72: 'Kom Hamada',
      73: 'El Mahmoudeya',
      74: 'Al Natron Valley',
      
      DATA: [
        { id: 1, name: 'Al Siala' },
        { id: 2, name: 'Abis' },
        { id: 3, name: 'El Azarita' },
        { id: 4, name: 'Al Ibrahimiyyah' },
        { id: 5, name: 'Al Hadarh' },
        { id: 6, name: 'Ad Dakhilah' },
        { id: 7, name: 'El Soyof' },
        { id: 8, name: 'Shatby' },
        { id: 9, name: 'El Salehya' },
        { id: 10, name: 'AZ Zahiriyyah' },
        { id: 11, name: 'Asafra' },
        { id: 12, name: 'Al Attarin' },
        { id: 13, name: 'Awayed' },
        { id: 14, name: 'Al Qabari' },
        { id: 15, name: 'Labban' },
        { id: 16, name: 'Al Mamurah' },
        { id: 17, name: 'Al Max' },
        { id: 18, name: 'El Mandara' },
        { id: 19, name: 'Mansheya' },
        { id: 20, name: 'Al Wardiyan' },
        { id: 21, name: 'Bacos' },
        { id: 22, name: 'Bahary' },
        { id: 23, name: 'Bolkly' },
        { id: 24, name: 'Gleem' },
        { id: 25, name: 'Janaklees' },
        { id: 26, name: 'El Montazah' },
        { id: 27, name: 'El Gomrok' },
        { id: 28, name: 'Ras el Tin' },
        { id: 29, name: 'Zizenia' },
        { id: 30, name: 'Saba Basha' },
        { id: 31, name: 'San Stefano' },
        { id: 32, name: 'Stanley' },
        { id: 33, name: 'Smouha' },
        { id: 34, name: 'Sidy Bishr' },
        { id: 35, name: 'Sidy Gaber' },
        { id: 36, name: 'Schutz' },
        { id: 37, name: 'El Amreya' },
        { id: 38, name: 'Fleming' },
        { id: 39, name: 'Victoria' },
        { id: 40, name: 'Camp Caesar' },
        { id: 41, name: 'Karmus' },
        { id: 42, name: 'Kafr Abdouh' },
        { id: 43, name: 'Kom Ad Dikah' },
        { id: 44, name: 'Loran' },
        { id: 45, name: 'Moharam Bek' },
        { id: 46, name: 'Mahatet El Raml' },
        { id: 47, name: 'Mahatet Misr' },
        { id: 48, name: 'Toson' },
        { id: 49, name: 'Miamy' },
        { id: 50, name: 'Mina El Basal' },
        { id: 51, name: 'Roshdy' },
        { id: 52, name: 'Sporting' },
        { id: 53, name: 'Abou Keir' },
        { id: 54, name: 'Cleopatra' },
        { id: 55, name: 'El Agamy' },
        { id: 56, name: 'Fouad Street' },
        { id: 57, name: 'King Mariout' },
        { id: 58, name: 'Moustafa Kamel' },
        { id: 59, name: 'Matrouh' },
        { id: 60, name: 'Damanhur' },
        { id: 61, name: 'Kafr El dawar' },
        { id: 62, name: 'Abu Al Matamir' },
        { id: 63, name: 'Abu Hummus' },
        { id: 64, name: 'Idku' },
        { id: 65, name: 'Itay Al Barud' },
        { id: 66, name: 'Badr' },
        { id: 67, name: 'Housh Eissa' },
        { id: 68, name: 'Ad Dilinjat' },
        { id: 69, name: 'AR Rahmaneyah' },
        { id: 70, name: 'Rasheed' },
        { id: 71, name: 'Shubrakhit' },
        { id: 72, name: 'Kom Hamada' },
        { id: 73, name: 'El Mahmoudeya' },
        { id: 74, name: 'Al Natron Valley' },
      ]
    }
  }
}

export default patientAreas



// WEBPACK FOOTER //
// ./src/constants/patientAreas.js